//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Somos1V2IndicadorTipo1Card',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: 'S/ MILLONES'
    },
    negocioLabel: {
      type: String,
      default: 'NEGOCIO'
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    totalItem: {
      type: Object,
      default: null
    }
  },
  methods: {
    fechaLabel: function fechaLabel(item) {
      if (!item || !item.fecha) return '';
      var meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
      var mes = meses[(item.fecha.month || 1) - 1] || '';
      return mes + ' ' + (item.fecha.year || '');
    },
    fmtMM: function fmtMM(v) {
      if (v === null || v === undefined) return '—';
      return (v / 1).toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    fmtPct: function fmtPct(v) {
      if (v === null || v === undefined) return '—';
      var sign = v >= 0 ? '+' : '';
      return "".concat(sign).concat((v * 100).toFixed(1), "%");
    },
    badgeClass: function badgeClass(v) {
      if (v === null || v === undefined) return 'badge na';
      if (v > 0) return 'badge pos';
      if (v < 0) return 'badge neg';
      return 'badge neu';
    }
  }
};